export async function uploadImage(
  file: File,
  bucket?: string,
): Promise<string> {
  // Stub - implement presigned URL upload here
  return '';
}
